define('galleryPageMoreResultsHandler',['builderShowcaseObserver', 'routes', 'sectionLazyLoad'], (builderShowcaseObserver, routes) => {
  'use strict';

  const moreResultsUrl = routes.BuilderShowcaseGalleryMoreResultsUrl;

  /**
   * Used to observe the target for the gallery's new page.
   * @param {*} target dom element used to observe.
   */
  function observe(target) {
    const data = builderShowcaseObserver.getState().data;
    window.SectionLazyLoad.observe(target);

    target.addEventListener('sectionLazyLoaded', (event) => {
      const container = target.closest('[data-section-gallery-images]');
      const response = event.detail.data;
      const responseFragment = document.createRange().createContextualFragment(response);
      container.appendChild(responseFragment);

      target.parentElement.removeChild(target);
    });

    builderShowcaseObserver.setData({
      activeCategoryCurrentPage: data.activeCategoryCurrentPage + 1,
    });

    builderShowcaseObserver.commit();
  }

  /**
   * Function used to build the URL for the next page.
   * @returns the url used in the next page.
   */
  function createMoreResultsUrl() {
    const data = builderShowcaseObserver.getState().data;
    const brandId = data.BrandId;
    const page = data.activeCategoryCurrentPage + 1;
    const category = data.activeCategory;
    const lastIndex = document.querySelectorAll('[data-section-gallery-images] [data-gallery-image]').length;

    let url;

    if (page <= 5) {
      url = `${moreResultsUrl}?page=${page}&category=${category}&brandId=${brandId}&lastIndex=${lastIndex}`;
    }

    return url;
  }

  return {
    observe,
    createMoreResultsUrl,
  };
});

